import { Skeleton, Table } from '@radix-ui/themes';

import styles from './TableDisplay.module.css';

interface TableSkeletonRowProps {
    columnCount: number;
}

export const TableSkeletonRow = ({ columnCount }: TableSkeletonRowProps) => {
    return (
        <Table.Row>
            {Array.from({ length: columnCount }).map((_, index) => (
                <Table.Cell key={index} className={styles.tableSkeletonCell}>
                    <Skeleton height={'100%'} width={'100%'}></Skeleton>
                </Table.Cell>
            ))}
        </Table.Row>
    );
};
